import { connect } from 'react-redux';

import { getItemsList } from '../Items/itemsActions';
import { getOfficesShortList } from '../Offices/officesActions';
import ItemTransactionsDashboard from './ItemTransactionsDashboard';
import { getItemTransactionsDashboardData } from './ItemTransactionsDashboardActions';

const mapStateToProps = state => ({
  officesShortList: state.office.officesShortList,
  itemsList: state.items.itemsList,
  itemTransactionsDashboardData: state.items.itemTransactionsDashboardData,
  isLoading: state.items.isItemTransactionsDashboardLoading,
});
const mapDispatchToProps = dispatch => ({
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getItemsList: params => dispatch(getItemsList(params)),
  getItemTransactionsDashboardData: params =>
    dispatch(getItemTransactionsDashboardData(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemTransactionsDashboard);
